<template lang="pug">
    .login
        robot
        gzzoc(v-if="config.name === 'gzzoc'")
</template>

<script>
import Gzzoc from './pages/gzzoc';
import Robot from './components/robot';
import { mapGetters } from 'vuex';
import 'public/images/gzzoc/eyeball.svg';

export default {
    data () {
        return {
        };
    },
    components: {
        Gzzoc,
        Robot,
    },
    computed: {
        ...mapGetters({
            config: 'config'
        })
    },
    created () {
    },
    mounted () {
    },
    methods: {
    }
};
</script>
<style lang="sass" scoped>
    .login
        width: 100%
        height: 100%
        min-height: 700px
        overflow: hidden
        position: relative
        background: url(~public/images/gzzoc/login_bg.jpg) no-repeat fixed center top / cover
</style>